import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '../../../shared/shared.module';
import { FieldErrorDisplayModule } from '../../../shared/field-error-display/field-error-display.module';
import { ButtonModule } from '../../../shared/button/button.module';
import { LoginFormComponent } from './login-form.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        FieldErrorDisplayModule,
        MatFormFieldModule,
        ButtonModule,
        MatProgressSpinnerModule,
    ],
    declarations: [LoginFormComponent],
    providers: [],
    exports: [LoginFormComponent],
})
export class LoginFormModule
{
}
